const weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export const defaultClassDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
const localDate = day => new Date(`${day}T12:00:00`);
const isoDay = day => `${day.getFullYear()}-${String(day.getMonth() + 1).padStart(2, "0")}-${String(day.getDate()).padStart(2, "0")}`;
export function sessionDates({start, end, repeat, classDays = defaultClassDays, mode = "all", selected = [], interval = 1}, validSchoolDay = () => true) {
    const available = classDays.length ? classDays : defaultClassDays;
    const allowed = mode === "custom" ? available.filter(day => selected.includes(day)) : available;
    const valid = day => allowed.includes(weekdays[localDate(day).getDay()]) && validSchoolDay(day);
    if (!start || !allowed.length) return [];
    if (repeat === "none") return valid(start) ? [start] : [];
    if (!end || end < start) return [];
    const beginning = localDate(start), ending = localDate(end), result = [];
    if (repeat === "monthly") {
        for (let month = 0; month < 120 && result.length < 366; month++) {
            const candidate = new Date(beginning.getFullYear(), beginning.getMonth() + month, 1, 12);
            candidate.setDate(Math.min(beginning.getDate(), new Date(candidate.getFullYear(), candidate.getMonth() + 1, 0).getDate()));
            const targetMonth = candidate.getMonth();
            while (candidate <= ending && candidate.getMonth() === targetMonth && !valid(isoDay(candidate))) candidate.setDate(candidate.getDate() + 1);
            if (candidate > ending) break;
            if (candidate.getMonth() === targetMonth && valid(isoDay(candidate))) result.push(isoDay(candidate));
        }
        return result;
    }
    for (const cursor = new Date(beginning); cursor <= ending && result.length < 366; cursor.setDate(cursor.getDate() + 1)) {
        const week = Math.floor((Date.UTC(cursor.getFullYear(), cursor.getMonth(), cursor.getDate()) - Date.UTC(beginning.getFullYear(), beginning.getMonth(), beginning.getDate())) / (7 * 86400000));
        if ((repeat !== "custom" || week % Math.max(1, Number(interval) || 1) === 0) && valid(isoDay(cursor))) result.push(isoDay(cursor));
    }
    return result;
}
const minutes = value => /^\d{2}:\d{2}$/.test(value || "") ? Number(value.slice(0, 2)) * 60 + Number(value.slice(3)) : null;
export function sessionWindow({classStart, classEnd, start, sections}) {
    const from = minutes(start || classStart), lower = minutes(classStart), upper = minutes(classEnd);
    const total = sections.reduce((sum, section) => sum + Math.max(1, Number(section.plannedMinutes ?? section.planned_minutes) || 15), 0);
    const end = from == null ? null : from + total;
    return {total, end, outside: from != null && lower != null && upper != null && (from < lower || end > upper),
        invalid: end != null && (from < 0 || from >= 1440 || end > 1440), endTime: end == null || end > 1440 ? "" : `${String(Math.floor(end / 60)).padStart(2, "0")}:${String(end % 60).padStart(2, "0")}`};
}
